export default __webpack_public_path__ + "static/media/universitycap.5dc86396.png";